var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import browserHistory from "@/common/browserHistory";
import { Router } from "react-router-dom";
import Routes from "./router";
import intl from 'react-intl-universal';
import { ChangePageTitle, userAgentObj } from "./common/funJs";
import EN from "@/common/language/json/en.json";
import ZH from "@/common/language/json/zh-cn.json";
import "./App.less";
var App = function (props) {
    var _a = useState(""), headerTitle = _a[0], setHeaderTitle = _a[1];
    useEffect(function () {
        var lang = (navigator.language ? navigator.language : navigator['browserLanguage']).toLowerCase();
        if (lang.indexOf('zh') >= 0) {
            // 假如浏览器语言是中文
            localStorage.setItem("defaultLng", "zh");
        }
        else {
            // 假如浏览器语言是其它语言
            localStorage.setItem("defaultLng", "en");
        }
        loadLocales();
        userAgentObj();
        ChangePageTitle(intl.get("companyHeaderBar"));
        setHeaderTitle(intl.get("company"));
        localStorage.setItem("headerTitle", intl.get("company"));
    }, []);
    var loadLocales = function () {
        intl.init({
            currentLocale: localStorage.getItem('locale') || localStorage.getItem("defaultLng") || 'zh',
            locales: {
                "en": EN,
                "zh": ZH
            },
        });
    };
    return (_jsx(Router, __assign({ history: browserHistory }, { children: _jsx(Routes, { headerTitle: headerTitle, setHeaderTitle: setHeaderTitle }) })));
};
export default App;
